import { MemberContext, MemberProvider } from "../../context/memberContext";
import Body from "../common/Body";
import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { generateHeadTags } from "react-seo-tools";
import { TITLE } from "../../config/config";
import HeroSection from "./section/HeroSection";
import SidebarSection from "./section/SidebarSection";
import SidenavSection from "./section/SidenavSection";
import ThreadListPromote from "../Forum/ForumView/ThreadListPromote";
import TabbedContents from "../common/TabbedContents";

const HeroContent = () => {
	const { user, userData, toggleFollowing, badges, fetchUserBadges } = useContext(MemberContext);

	useEffect(() => {
		fetchUserBadges();
	}, [fetchUserBadges]);

	if (user && userData && badges) {
		return <HeroSection user={user} userData={userData} toggleFollowing={toggleFollowing} badges={badges} />;
	}

	return null;
};

const SidebarContent = () => {
	return <SidebarSection />;
};

const SidenavContent = () => {
	return <SidenavSection />;
};

const MainContent = () => {
	const {
		user,
		promoteThreads,
		promoteThreadsLoading,
		hasMorePromoteThreads,
		loadMorePromoteThreads,
		lockedThreads,
		lockedThreadsLoading,
		hasMoreLockedThreads,
		loadMoreLockedThreads,
	} = useContext(MemberContext);

	const tabContents = [
		{
			label: "GÁI GỌI ĐANG HOẠT ĐỘNG",
			content: (
				<ThreadListPromote
					threads={promoteThreads}
					threadsLoading={promoteThreadsLoading}
					hasMoreThreads={hasMorePromoteThreads}
					loadMoreThreads={loadMorePromoteThreads}
				/>
			),
		},
		{
			label: "GÁI GỌI TẠM NGHỈ",
			content: (
				<ThreadListPromote
					threads={lockedThreads}
					threadsLoading={lockedThreadsLoading}
					hasMoreThreads={hasMoreLockedThreads}
					loadMoreThreads={loadMoreLockedThreads}
				/>
			),
		},
	];

	useEffect(() => {
		if (user) {
			document.title = `${user.username} | ${TITLE}`;
		}
	}, [user]);

	return (
		<div>
			{user && (
				<Helmet>
					{generateHeadTags({
						title: user.username,
						description: user.user_title,
						openGraph: {
							type: "profile",
							title: user.username,
							image: user.avatar_urls.o,
							"profile:username": user.username,
						},
					})}
				</Helmet>
			)}

			{promoteThreads && lockedThreads && (
				<section className="mb-4">
					<TabbedContents tabContents={tabContents} hasBorder={false} />
				</section>
			)}
		</div>
	);
};

const MemberView = () => {
	return (
		<MemberProvider>
			<Body
				mainContent={<MainContent />}
				sidebarContent={<SidebarContent />}
				sidenavContent={<SidenavContent />}
				heroContent={<HeroContent />}
			/>
		</MemberProvider>
	);
};

export default MemberView;
